import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  RentalState,
  RentalParams,
  RentalApiResponse,
  MonthWeekRentalApiResponse,
  MonthTimeRentalApiResponse,
  RentalPerDayApiResponse,
} from "./RentalType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

//情報取得API連携
export const fetchAsyncRental: any = createAsyncThunk<
  RentalParams,
  RentalApiResponse
>("Rental/get", async () => {
  const response = await axiosSettings.get(
    "api-admin/afterrental/rental-total"
  );
  return response.data;
});

//月ごとの週別登録者数
export const fetchAsyncRentalMonthWeek: any = createAsyncThunk<
  MonthWeekRentalApiResponse & { page: number },
  RentalParams
>("RentalMonthWeek/get", async (page) => {
  const response = await axiosSettings.get(
    `api-admin/afterrental/rental-month-week?page=${page}`
  );

  return response.data;
});

//月ごとの年齢別登録者数
export const fetchAsyncRentalMonthTime: any = createAsyncThunk<
  MonthTimeRentalApiResponse,
  RentalParams
>("RentalMonthTime/get", async (page) => {
  const response = await axiosSettings.get(
    `api-admin/afterrental/rental-month-time?page=${page}`
  );
  return response.data;
});

//直近7日間の登録者数
export const fetchAsyncRentalPerDay: any = createAsyncThunk<
  RentalPerDayApiResponse,
  RentalParams
>("RentalPerDay/get", async (page) => {
  const response = await axiosSettings.get(
    `api-admin/afterrental/rental-per-day?page=${page}`
  );
  return { ...response.data, page };
});

const initialState: RentalState = {
  rental: null,
  rentalMonthWeek: null,
  rentalMonthTime: null,
  rentalPerDay: null,
  updatedTime: "",
  loading: false,
  error: "",
};

const RentalSlice = createSlice({
  name: "Rental",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    //登録者数
    builder.addCase(fetchAsyncRental.fulfilled, (state, action) => {
      if (action.payload.status === "Success") {
        state.rental = action.payload.data.result;
        state.updatedTime = GetTime();
        state.error = "";
      } else {
        state.error = action.payload.data.result;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncRental.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncRental.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.data.result || "Failed to fetch users";
    });
    //月ごとの週ごとの登録者数
    builder.addCase(fetchAsyncRentalMonthWeek.fulfilled, (state, action) => {
      state.rentalMonthWeek = action.payload.data.result;
      state.error = "";
      state.loading = false;
    });
    builder.addCase(fetchAsyncRentalMonthWeek.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncRentalMonthWeek.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.data.result || "Failed to fetch users";
    });
    //月ごとの年齢ごとの登録者数
    builder.addCase(fetchAsyncRentalMonthTime.fulfilled, (state, action) => {
      state.rentalMonthTime = action.payload.data.result;
      state.error = "";
      state.loading = false;
    });
    builder.addCase(fetchAsyncRentalMonthTime.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncRentalMonthTime.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.data.result || "Failed to fetch users";
    });
    //直近7日間の登録者数
    builder.addCase(fetchAsyncRentalPerDay.fulfilled, (state, action) => {
      state.rentalPerDay = action.payload.data.result;
      state.error = "";
      state.loading = false;
    });
    builder.addCase(fetchAsyncRentalPerDay.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncRentalPerDay.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.data.result || "Failed to fetch users";
    });
  },
});

export const RentalInfo = (state: RootState) => state.Rental.rental;
export const RentalMonthWeek = (state: RootState) =>
  state.Rental.rentalMonthWeek;
export const RentalMonthTime = (state: RootState) =>
  state.Rental.rentalMonthTime;
export const RentalPerDay = (state: RootState) => state.Rental.rentalPerDay;
export const RentalError = (state: RootState) => state.Rental.error;
export const RentalLoading = (state: RootState) => state.Rental.loading;
export const RentalUpdatedTime = (state: RootState) => state.Rental.updatedTime;
export default RentalSlice.reducer;
